<template lang="pug">
  .article
    BgImage(:bgimage="article.img")
    Hero(:text="article.title", :bajada="article.undertitle", :bgimage="article.img")
    .text
      .credits(v-html="article.credits")
      Sharer(:baseurl="config.baseurl", :slug="$route.path", :title="article.share.title || config.title", :description="article.share.description || config.description", :img="article.share.img || config.img", :hashtag="config.hashtag", :brandtitle="config.brandtitle", :reporttitle="config.reporttitle")
      Content(:article="article")
</template>
<script>
import { mapState } from 'vuex'
import Hero from '@/components/Hero'
import BgImage from '@/components/transition/BgImage'
import Content from '@/components/Content'
import Sharer from '@/components/Sharer'

export default {
  components: {
    Hero,
    BgImage,
    Content,
    Sharer
  },
  props: {
    slug: {
      type: String,
      required: true
    }
  },
  mounted(){
    console.log(this.article)
  },
  computed: {
    article(){
      const article = this.$store.getters.getArticle(this.slug)
      if(typeof article === 'undefined'){
        this.$router.push({name: 'home'})
      }
      return article
    },
    ...mapState([
      'config'
    ])
  },
  metaInfo() {
    console.log('metainfo', this.article.share)
    return {
      title: 'Especial Transición - La Tercera - Presentado por Wom',
      titleTemplate: this.article.share.title + ' - %s',
      meta: [
        {
          'property': 'description',
          'content': this.article.share.description,
          'vmid': 'description'
        },
        {
          'property': 'og:title',
          'content': this.article.share.title,
          'vmid': 'og:title'
        },
        {
          'property': 'og:description',
          'content': this.article.share.description,
          'vmid': 'og:description'
        },
        {
          'property': 'og:url',
          'content': this.config.baseurl + this.$route.path,
          'vmid': 'og:url'
        },
        {
          'property': 'og:image',
          'content': this.config.baseurl + this.article.img,
          'vmid': 'og:image'
        }
      ]
    }
  }
}
</script>
<style lang="scss">
  .text{
    position: relative;
    z-index: 2;
    padding: 1px 0;
    color: white;
  }

  .credits{
    max-width: $maxwidth;
    text-align: center;
    margin: 6rem auto;
    padding: 0 1rem;
    p{
      text-indent: 0;
      font-family: 'Open Sans', sans-serif;
      margin: 0;
      padding: 0;
      font-size: 1rem;
    }
  }
  .sharer{
    padding-bottom: 2rem;
  }

</style>


